import React, { useCallback, useContext } from "react";
import lodashGet from "lodash/get";
import styles from "./shareguide.module.less";
import { getTextRemark } from "@/components/chat/utils/commonMessageModal";
import GlobalContext from "@/context/GlobalContext";

interface IProps {
  message: any;
}
/**
 * AI欢迎卡片
 */
function ShareGuideCard(props: IProps) {
  const { appRuntimeEnv } = useContext(GlobalContext);
  const { gateway } = appRuntimeEnv.envConfig || {};
  const { message } = props;
  const dataInfos = lodashGet(message, "data", []);

  const handleLinkClick = useCallback(
    (item: any) => {
      const { link } = item;
      if (link) {
        const gatewayHost = new URL(gateway.protocol + "://" + gateway.host).origin;
        window.open(`${gatewayHost}${link}`);
      }
    },
    [gateway.host, gateway.protocol]
  );
  return dataInfos?.map((item: any, idx: number) => {
    const { content = "" } = item;
    return (
      <div key={`${item.id}_guide_${idx}`} className={styles["ai-share-guide-wrap"]}>
        <span
          className={styles["content"]}
          dangerouslySetInnerHTML={{
            __html: getTextRemark(content, message.id)
          }}
        />
        {item?.link ? (
          <div
            className={styles["card-link"]}
            onClick={() => handleLinkClick(item)}
            clstag="pageclick|keycount|Xtbg_Opening_AIOverview"
          >
            <div className={styles["left"]}>
              <span className={styles["icon"]} />
              <span className={styles["text"]}>AI功能全览</span>
            </div>
            <span className={styles["more"]}>{"了解更多>"}</span>
          </div>
        ) : null}
      </div>
    );
  });
}

export default ShareGuideCard;
